import React, { Component, Fragment } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import CircularProgress from '@material-ui/core/CircularProgress'
import PageModal from '../../Ui/Modal/Modal'
import FacebookLogin from './FacebookSignIn'
import GoogleLogin from './GoogleSignIn'
import FormsInput from '../../Ui/FormsInput'
import Buttons from '../../Ui/buttons/Buttons'

import FacebookIcon from '@material-ui/icons/Facebook'
import GoogleIcon from '../../../assets/images/google.png'
import { checkValidity } from '../../../shared/utility'
import { Redirect } from 'react-router-dom'
// import FacebookLogin from 'react-facebook-login'

import { connect } from 'react-redux'
import * as actions from '../../../store/actions/index'


class Login extends Component {

    _isMounted = false
    state = {
        authForm: {
            email: {
                label: 'Email',
                variant: 'outlined',
                elementType: 'input',
                elementConfig: {
                    required: true,
                    maxLength: 200,
                    type: "email",
                },
                type: "email",
                name: 'email',
                value: '',
                validation: {
                    required: true,
                    minLength: 1,
                    maxLength: 200,
                    isEmail: true
                },
                invalid: {
                    isValid: false,
                    isValidMessage: ''
                },
                touched: false,
                classname: 'col-sm-12'
            },
            password: {
                elementType: 'password',
                classname: 'mt-3',
                label: 'Password',
                elementConfig: {
                    required: true,

                    maxLength: 100,
                    type: "email",
                },
                type: "password",
                name: 'password',
                value: '',
                validation: {
                    required: true,
                    minLength: 1
                },
                invalid: {
                    isValid: false,
                    isValidMessage: ''
                },
                classname: 'col-sm-12 mt-3',
                touched: false
            },
        },
        formIsValid: false,
        loading: ''
    }

    constructor(props) {
        super(props)
    }
 
    // handle input changes when user enter value to change state
    handleChange = (event, name) => {
        event.preventDefault()
        const newAuthForm = {
            ...this.state.authForm,
            [name]: {
                ...this.state.authForm[name],
                value: event.target.value,
                invalid: checkValidity(event.target.value, this.state.authForm[name].validation),
                touched: true
            }
        }
        this.setState({ authForm: newAuthForm })
        let formIsValid = true
        for (let inputIdentifier in newAuthForm) {
            if (newAuthForm[inputIdentifier].invalid !== false) {
                formIsValid = newAuthForm[inputIdentifier].invalid.isValid && formIsValid
            }
        }
        this.setState({ formIsValid: formIsValid })
    }

    responseFacebook = () => {
        this.props.showModal("facebook")
        this.props.onAuthFacebook()
    }

    responseGoogle = () => {
        this.props.showModal('google')
        this.props.onAuthGoogleUrl()
    }

    // submit login detail
    handleSubmit = (event) => {
        event.preventDefault()
        console.log(this.state.authForm.email.value)
        this.props.onAuth(this.state.authForm.email.value, this.state.authForm.password.value)
    }

    // handleFacebook = (event, url)=>{
    //     event.preventDefault()
    //     //this.props.onAuthFacebook()
    // }


    render() {

        const {
            authForm,
            NewUserForm,
            formload,
            formIsValid,
        } = this.state


        // check user any session login and redirect using redux
        let authRedirect
        if (this.props.isAuthenticated) {
            // console.log(this.props.history.location.state.from)
            authRedirect = <Redirect to={this.props.authRedirectPath} />
        }


        // return customise message as the backend return only unauthorized
        let errorMsg
        if (this.props.error) {
            let msg = 'You have entered an invalid username or password'
            if (this.props.error == 'Unauthorized') {
            }
            errorMsg = (
                <p className="mt-3">{msg}</p>
            )
        }


        // create formElement from state
        const formElementsArray = []
        for (let key in authForm) {
            formElementsArray.push({
                id: key,
                config: authForm[key]
            })
        }

        console.log(this.props.googleUrl)

        return (
           
            <Container>
                {authRedirect}
                {
                    this.props.googleUrl && <PageModal
                        dialogClassName="col-md-6"
                        modalName="google"
                        title={''}
                        component={<GoogleLogin googleUrl={this.props.googleUrl} />}
                    />
                }
                {
                    this.props.facebookUrl && <PageModal
                        dialogClassName="col-md-6"
                        modalName="facebook"
                        title={''}
                        component={<FacebookLogin facebookUrl={this.props.facebookUrl} />}
                    />
                }
                <Row className="justify-content-md-center">
                    <Col md={6}>
                        <Row className="p-3">
                            <Col md={12}>
                                <Row>
                                    <Col md={12} className="text-center">
                                        <h5>Please sign in</h5>
                                    </Col>
                                </Row>
                                <form
                                    className="form mt-2"
                                    onSubmit={event => this.handleSubmit(event)}  >
                                    {
                                        formElementsArray.map((formElement, index) => (
                                            <FormsInput
                                                key={index}
                                                label={formElement.config.label}
                                                invalid={formElement.config.invalid}
                                                elementConfig={formElement.config.elementConfig}
                                                elementType={formElement.config.elementType}
                                                variant={formElement.config.variant}
                                                value={formElement.config.value}
                                                shouldValidiate={formElement.config.validation}
                                                classname={formElement.config.classname}
                                                touched={formElement.config.touched}
                                                changed={(event) => this.handleChange(event, formElement.config.name)}

                                            />

                                        ))

                                    }
                                </form>
                                <p className="text-left mt-3 forget-password small"><a href="#" className="alter-link">Forget Password ?</a></p>
                            </Col>
                            <Col sm={12}>
                                <Buttons
                                    buttonType="primary"
                                    buttonAction={this.handleSubmit}
                                    buttontext="Login"
                                    classInput="col-sm-12"
                                    disabled={!formIsValid}
                                />
                            </Col>
                            <Col sm={12} className="text-center">
                                <p>or</p>
                            </Col>
                            <Col sm={12}>
                                <Buttons
                                    buttonType="icon-btn"
                                    buttonAction={this.responseFacebook}
                                    buttontext="Continue with Facebook"
                                    icon={<FacebookIcon />}
                                    classInput="col-sm-12 btn-facebook mt-3"
                                />

                            </Col>
                            <Col sm={12}>
                                <Buttons
                                    buttonType="icon-btn"
                                    buttonAction={this.responseGoogle}
                                    buttontext="Sign in with google"
                                    icon={<img src={GoogleIcon} width={18} />}
                                    classInput="col-sm-12 btn-google mt-2"
                                />
                            </Col>
                            <Col sm={12} className="text-center mt-4">
                                Not a member yet? <a href="#" onClick={() => this.props.showModal("register")}>Sign Up</a>
                                {/* <Buttons
                            buttonType="secondary"
                            buttontext="Sign up"
                            classInput="col-sm-12"
                            buttonAction={() => this.props.showModal("register")}
                            disabled={this.props.loading}
                        /> */}
                                {errorMsg}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        )


    }



}


const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null,
        authRedirectPath: state.auth.authRedirectPath,
        facebookUrl: state.auth.facebookUrl,
        googleUrl: state.auth.googleUrl

    }
}
const mapDispatchToProps = dispatch => {
    return {
        onAuth: (email, password) => dispatch(actions.auth(email, password)),
        onAuthFacebook: () => dispatch(actions.authFacebook()),
        onSetAuthRedirectPath: (path) => dispatch(actions.setAuthRedirectPath(path)),
        onAuthGoogleUrl: () => dispatch(actions.authGoogle()),
        showModal: (name) => dispatch(actions.modalShow(name))
    }
}


// export default Login

export default connect(mapStateToProps, mapDispatchToProps)(Login)